/* eslint-disable no-template-curly-in-string */
import { Locale } from '../locales';

export const globalTranslation = {
  [Locale.en]: {
    chains: {
      1: 'Ethereum Mainnet',
      3: 'Ropsten',
      4: 'Rinkeby',
      5: 'Ethereum Goerli',
      6: 'Kotti',
      56: 'BNB Chain',
      61: 'Classic',
      63: 'Mordor',
      97: 'BNB Chain Testnet',
      137: 'Polygon Mainnet',
      43113: 'Avalanche C-Chain',
      43114: 'Avalanche',
      2018: 'Dev',
      250: 'Fantom Opera',
      4002: 'Fantom Testnet',
      80001: 'Mumbai',
      unknownNetwork: 'Unknown network',
    },
    nativeTokenByChainId: {
      56: 'BNB',
      97: 'BNB',
      137: 'MATIC',
      80001: 'MATIC',
    },
    units: {
      $: '${value}',
      tokenAmount: '{amount} {token}',
      shortDay: '{date, time, ::EEE}',
      fullDay: '{date, time, ::eeeee}',
    },
    time: {
      everyXMinute: 'Every x minutes',
      everyXHours: 'Every x hours',
      everyMinute: 'Every {value}min',
      everyHour: 'Every {value}h',
    },
  },
};
